import React from 'react';
import Box from '@mui/material/Box';
import FilterSelect from '../FilterSelect';
import MultiFilterSelect from '../MultiFilterSelect';
import SearchField from '../SearchField';
import { filterBarSx } from '../filterStyles';
import { AREA_OPTIONS, TYPE_OPTIONS } from '../../changelogAdminConfig';

const STATUS_OPTIONS = [
  { value: 'draft', label: 'Rascunho' },
  { value: 'reviewed', label: 'Revisado' },
  { value: 'published', label: 'Publicado' },
  { value: 'internal', label: 'Interno' },
  { value: 'discarded', label: 'Descartado' },
];

const SENT_OPTIONS = [
  { value: '', label: 'Enviado ou não' },
  { value: 'nao', label: 'Ainda não enviado' },
  { value: 'sim', label: 'Já enviado' },
];

/**
 * Busca e filtros do catálogo de novidades (aba Catálogo e seletor de itens do envio).
 * status, type e area são { values, exclude } (mostrar só ou esconder os marcados).
 * @param {{ filters: { status, sent, type, area }, onFilterChange: Function, searchInput: string, onSearchInputChange: Function }} props
 */
function CatalogFilters({ filters, onFilterChange, searchInput, onSearchInputChange }) {
  return (
    <Box sx={filterBarSx}>
      <SearchField value={searchInput} onChange={onSearchInputChange} placeholder="Buscar por título, resumo ou identificador" />
      <MultiFilterSelect label="Status" value={filters.status} options={STATUS_OPTIONS} onChange={(value) => onFilterChange('status', value)} />
      <FilterSelect value={filters.sent} options={SENT_OPTIONS} onChange={(value) => onFilterChange('sent', value)} />
      <MultiFilterSelect label="Tipo" value={filters.type} options={TYPE_OPTIONS} onChange={(value) => onFilterChange('type', value)} />
      <MultiFilterSelect label="Área" value={filters.area} options={AREA_OPTIONS} onChange={(value) => onFilterChange('area', value)} />
    </Box>
  );
}

export default CatalogFilters;
